import { render } from "./SelectTagField.vue?vue&type=template&id=394eae18&scoped=true"
import script from "./SelectTagField.vue?vue&type=script&lang=js"
export * from "./SelectTagField.vue?vue&type=script&lang=js"

import "./SelectTagField.vue?vue&type=style&index=0&id=394eae18&scoped=true&lang=scss"

import exportComponent from "/Users/xujunfeng/Desktop/project/school/digital_factory_server/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394eae18"]])

export default __exports__